<div class="main-container-wrapper">
    <app-informate-sub-header (newMatrix)="addMatrix($event)" [headerData]="subHeaderData"></app-informate-sub-header>
    <div class="container-fluid" style="flex: 1; padding: 0px 15px 0px 15px">
        <div class="row" style="margin: 0 auto; max-height: 100%; min-height: 100%">
            <div class="col-lg-12" style="padding: 0px">
                <div class="card card-custom gutter-b card-stretch">
                    <div class="card-body">
                        <h4 style="margin-bottom: 20px">Joint Matrix</h4>
                        <app-matrix-list [newlyAddedMatrix]="newlyAddedMatrix"></app-matrix-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
